import { render, staticRenderFns } from "./projectTab.vue?vue&type=template&id=181ed357&scoped=true&"
import script from "./projectTab.vue?vue&type=script&lang=js&"
export * from "./projectTab.vue?vue&type=script&lang=js&"
import style0 from "./projectTab.vue?vue&type=style&index=0&id=181ed357&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ed357",
  null
  
)

export default component.exports